export default "__VITE_ASSET__CLLn6DVb__"